"use client";

import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "@/components/icons";
import NotifyMe from "@/components/partials/modal/notify-me";
import { HeroSkeleton } from "./components/loader";
import moment from "moment";
import Enroll from "@/components/partials/modal/enroll";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

const Hero = ({
  isLoading,
  data,
  batches,
  status: propsStatus,
}: {
  isLoading: boolean;
  data: any;
  batches: any;
  status?: string;
}) => {
  const { status: clientStatus } = useSession();

  const [status, setStatus] = useState<string>(propsStatus ?? "loading");

  useEffect(() => {
    if (clientStatus === "loading") return;
    setStatus(clientStatus);
  }, [clientStatus]);

  const backgroundStyle = {
    background: data?.image
      ? `linear-gradient(90deg, rgba(20, 23, 42, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), 
         linear-gradient(0deg, rgba(26, 26, 26, 0.40) 0%, rgba(26, 26, 26, 0.40) 100%), 
         url(${data.image}) lightgray 50% / cover no-repeat`
      : `linear-gradient(90deg, rgba(20, 23, 42, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), 
         linear-gradient(0deg, rgba(26, 26, 26, 0.40) 0%, rgba(26, 26, 26, 0.40) 100%)`,
  };

  return (
    <div
      className="flex min-h-screen w-full flex-col pt-20 lg:pt-32"
      style={backgroundStyle}
    >
      <div className="flex flex-1 items-center">
        {isLoading ? (
          <HeroSkeleton />
        ) : (
          <div className="container grid grid-cols-1 gap-8 py-10 lg:grid-cols-2 lg:gap-12 lg:py-20">
            <div className="flex items-center">
              <div className="flex flex-col items-start gap-12">
                <div className="flex flex-col gap-6">
                  <h2 className="text-5xl leading-[60px] font-semibold text-white lg:text-6xl lg:leading-[78px]">
                    {data?.title}
                  </h2>
                  <p className="text-base font-medium text-slate-50 lg:text-3xl">
                    {data?.description}
                  </p>
                </div>
                {status === "unauthenticated" && (
                  <Enroll>
                    <Button
                      variant="outline"
                      className="w-full rounded-full bg-transparent text-white lg:w-fit"
                      size="2xl"
                    >
                      Enroll Now
                      <ArrowUpRight />
                    </Button>
                  </Enroll>
                )}
              </div>
            </div>

            <div className="hidden h-fit overflow-hidden rounded-2xl border border-blue-200 bg-slate-50 lg:block">
              <div className="flex w-full flex-col justify-between gap-4 bg-blue-200 px-6 py-4 lg:flex-row lg:items-center">
                <h3 className="text-primary text-2xl font-semibold lg:text-3xl">
                  Upcoming{" "}
                  <span className="font-vollkorn font-normal italic">
                    Sessions
                  </span>
                </h3>
                <NotifyMe />
              </div>
              <ul className="max-h-[300px] overflow-y-auto [&>*:nth-child(even)]:bg-slate-50 [&>*:nth-child(odd)]:bg-white">
                {batches &&
                  batches.map((batch: any) => (
                    <li
                      key={batch.id}
                      className="text-primary border-b border-slate-100 px-6 py-3 text-lg font-medium lg:py-4 lg:text-xl"
                    >
                      {moment(batch.start_date).format("MMMM DD, YYYY")} -{" "}
                      {moment(batch.end_date).format("MMMM DD, YYYY")}
                    </li>
                  ))}
                {!batches.length && (
                  <li className="text-primary border-b border-slate-100 px-6 py-3 text-center text-lg font-medium lg:py-4 lg:text-xl">
                    No Upcoming Sessions
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
